<template lang="pug">

</template>

<script>
import Resumable from 'resumablejs'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  data () {
    return {
      fileAdded: null,
      resumableError: false,
      resumable: null
    }
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    target: {
      type: String,
      required: true
    },

    classInput: {
      type: String,
      required: false
    },
    idInput: {
      type: String,
      required: false
    },

    classDrop: {
      type: String,
      required: false
    },
    idDrop: {
      type: String,
      required: false
    },

    maxSize: {
      type: Number,
      required: false
    },

    fileType: {
      type: Array,
      required: true
    },

    fileTypeErrorCallback: {
      type: Function,
      required: false
    }
  },

  mounted () {
    this.createdResumable()
  },
  methods: {
    createdResumable () {
      this.$nextTick(() => {
        let r = new Resumable({
          target: this.target,
          chunkSize: 1 * 1024 * 1024,
          simultaneousUploads: 1,
          forceChunkSize: true,
          testChunks: false,
          fileType: this.fileType,
          fileTypeErrorCallback: this.fileTypeErrorCallback
        })
        this.resumable = r

        if (!this.resumable.support) {
          this.resumableError = true
          return
        }

        if (this.classInput) {
          this.resumable.assignBrowse(document.getElementsByClassName(this.classInput))
        }
        if (this.idInput) {
          this.resumable.assignBrowse(document.getElementById(this.idInput))
        }

        if (this.classDrop) {
          this.resumable.assignDrop(document.getElementsByClassName(this.classDrop))
        }
        if (this.idDrop) {
          this.resumable.assignDrop(document.getElementById(this.idDrop))
        }

        this.resumable.on('fileAdded', file => {
          if (this.resumable.files.length > 1) {
            this.resumable.files.forEach(file => file.cancel())
            this.resumable.files = []
            this.showNotificacao(
              this.$messages.TIPO_WARNING,
              this.$messages.TITULO_WARNING,
              'Apenas um arquivo pode ser enviado por vez.'
            )
            return
          }
          if (this.resumable.files.length === 0) {
            return
          }
          if (this.fileAdded !== null) {
            this.fileAdded.cancel()
          }

          this.fileAdded = file

          const maxSize = this.maxSize || 10

          if (!(this.fileAdded.file.size < maxSize * 1048576)) {
            this.showNotificacao(
              this.$messages.TIPO_WARNING,
              this.$messages.TITULO_WARNING,
              'Arquivo deve ter no máximo ' + maxSize + 'MB de tamanho!'
            )
            this.fileAdded.cancel()
            return
          }

          this.$emit('fileAdded', file)
        })

        this.resumable.on('fileSuccess', (file, fileKey) => {
          this.$emit('onSuccess', file, fileKey)
          this.removeFile()
        })

        this.resumable.on('fileError', (file, error) => {
          error = JSON.parse(error)

          this.removeFile()

          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
          this.$emit('onError', error)
        })

        this.resumable.on('fileProgress', file => {
          const percentage = Math.floor(file.progress() * 100)
          this.$emit('onProgress', percentage)
        })
      })
    },

    removeFile () {
      if (this.fileAdded !== null) {
        this.fileAdded.cancel()
        this.fileAdded = null
      }
    },

    uploadFile () {
      this.resumable.upload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppResumable.vue